import { render, staticRenderFns } from "./addUserModel.vue?vue&type=template&id=bd4854ec&scoped=true&"
import script from "./addUserModel.vue?vue&type=script&lang=js&"
export * from "./addUserModel.vue?vue&type=script&lang=js&"
import style0 from "./addUserModel.vue?vue&type=style&index=0&id=bd4854ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4854ec",
  null
  
)

export default component.exports